function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.956 30.9928L33.9541 30.2918C35.7899 27.589 36.7602 24.4174 36.7602 21.1216C36.7602 12.1997 29.6074 4.9411 20.8148 4.9411C17.851 4.9411 14.9585 5.77184 12.4501 7.34375L11.8103 6.29252C14.5111 4.60078 17.6252 3.70581 20.8148 3.70581C30.2782 3.70581 37.9776 11.5184 37.9776 21.1216C37.9776 24.6694 36.933 28.0831 34.956 30.9928ZM20.8149 38.5364C11.3515 38.5364 3.65207 30.7244 3.65207 21.1212C3.65207 17.6754 4.64242 14.3432 6.51598 11.4859L7.52946 12.1703C5.7892 14.8237 4.86946 17.9194 4.86946 21.1212C4.86946 30.0431 12.0229 37.3011 20.8149 37.3011C24.145 37.3011 27.334 36.2709 30.039 34.321L30.7439 35.3284C27.8325 37.4271 24.3989 38.5364 20.8149 38.5364ZM36.3975 37.8065C36.5162 37.927 36.6721 37.9875 36.8279 37.9875C36.9837 37.9875 37.1395 37.927 37.2582 37.8065C37.4962 37.565 37.4962 37.1747 37.2582 36.9332L5.23233 4.4363C4.99433 4.1948 4.60902 4.1948 4.37163 4.4363C4.13363 4.67718 4.13363 5.06815 4.37163 5.30965L36.3975 37.8065Z",
  fill: "#7BAF9E"
});

var SvgNoAnswer = function SvgNoAnswer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoAnswer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-answer.d02ec198.svg";
export { ForwardRef as ReactComponent };